/* Program Name: MenuIcon.js
 **  Description: function that will return an Icon based on what String is
 **               passed.
 **
 ** Project    Date        Who  Comments
 ** ---------  ----------  ---  ---------------------------------------------------
 ** IS0200241  2021-03-17  STT  Initial program
 ** SD9567     2025-04-16  sgs  SD9681 - CLV: Inventory Maintenance
 ** SD9567     2025-09-29  sgs  SD11301 - Promo Builder - Target/Add Stores By DMA Dropdown
 *********************************************************************************/

/**Icon imports */
import {
  AccessTime,
  AccountBox,
  AccountCircle,
  AdminPanelSettings,
  Apps,
  Build,
  BurstMode,
  CorporateFare,
  Domain,
  EditAttributes,
  ErrorOutline,
  Fastfood,
  Groups,
  History,
  Home,
  Image,
  InsertChart,
  List,
  ListAlt,
  LocalFireDepartment,
  LocalMall,
  LocalShipping,
  ReceiptLong,
  //Route,
  Schema,
  Security,
  SettingsApplications,
  Store,
  Storefront,
  TripOrigin,
  Update,
  Whatshot,
  Inventory,
  Map,
} from '@mui/icons-material'
import ApartmentIcon from '@mui/icons-material/Apartment'

/**GetIcon  */
/**takes in the name of the menu item and returns the correct icon for the menu item */
export const GetIcon = ({ iconName, overrideStyles, fontSize }) => {
  switch (iconName) {
    case 'Whatshot': {
      return <Whatshot fontSize={fontSize} style={{ ...overrideStyles }} />
    }
    case 'Home': {
      return <Home fontSize={fontSize} style={{ ...overrideStyles }} />
    }
    case 'Maintenance': {
      return <Build fontSize={fontSize} style={{ ...overrideStyles }} />
    }
    case 'Schematics': {
      return <Apps fontSize={fontSize} style={{ ...overrideStyles }} />
    }
    case 'Promotions': {
      return <Fastfood fontSize={fontSize} style={{ ...overrideStyles }} />
    }
    case 'Location Profiles': {
      return <Store fontSize={fontSize} style={{ ...overrideStyles }} />
    }
    case 'Account': {
      return <AccountCircle fontSize={fontSize} style={{ ...overrideStyles }} />
    }
    case 'Store Profiles': {
      return <Storefront fontSize={fontSize} style={{ ...overrideStyles }} />
    }
    case 'Orders': {
      return <ListAlt fontSize={fontSize} style={{ ...overrideStyles }} />
    }
    case 'Reports': {
      return <InsertChart fontSize={fontSize} style={{ ...overrideStyles }} />
    }
    case 'LocalShipping': {
      return <LocalShipping fontSize={fontSize} style={{ ...overrideStyles }} />
    }
    case 'History': {
      return <History fontSize={fontSize} style={{ ...overrideStyles }} />
    }
    case 'Update': {
      return <Update fontSize={fontSize} style={{ ...overrideStyles }} />
    }
    case 'Store': {
      return <Store fontSize={fontSize} style={{ ...overrideStyles }} />
    }
    case 'Domain': {
      return <Domain fontSize={fontSize} style={{ ...overrideStyles }} />
    }
    case 'AdminPanelSettings': {
      return (
        <AdminPanelSettings fontSize={fontSize} style={{ ...overrideStyles }} />
      )
    }
    case 'Apartment': {
      return <ApartmentIcon fontSize={fontSize} style={{ ...overrideStyles }} />
    }
    case 'Groups': {
      return <Groups fontSize={fontSize} style={{ ...overrideStyles }} />
    }
    case 'SettingsApplications': {
      return (
        <SettingsApplications
          fontSize={fontSize}
          style={{ ...overrideStyles }}
        />
      )
    }
    case 'List': {
      return <List fontSize={fontSize} style={{ ...overrideStyles }} />
    }
    case 'Security': {
      return <Security fontSize={fontSize} style={{ ...overrideStyles }} />
    }
    /*   case 'Route': {
      return <Route style={{ ...overrideStyles }} />
    } */
    case 'ErrorOutline': {
      return <ErrorOutline fontSize={fontSize} style={{ ...overrideStyles }} />
    }
    case 'EditAttributes': {
      return (
        <EditAttributes fontSize={fontSize} style={{ ...overrideStyles }} />
      )
    }
    case 'Image': {
      return <Image fontSize={fontSize} style={{ ...overrideStyles }} />
    }
    case 'BurstMode': {
      return <BurstMode fontSize={fontSize} style={{ ...overrideStyles }} />
    }
    case 'Schema': {
      return <Schema fontSize={fontSize} style={{ ...overrideStyles }} />
    }
    case 'CorporateFare': {
      return <CorporateFare fontSize={fontSize} style={{ ...overrideStyles }} />
    }
    case 'ReceiptLong': {
      return <ReceiptLong fontSize={fontSize} style={{ ...overrideStyles }} />
    }
    case 'AccountBox': {
      return <AccountBox fontSize={fontSize} style={{ ...overrideStyles }} />
    }
    case 'LocalFireDepartment': {
      return (
        <LocalFireDepartment
          fontSize={fontSize}
          style={{ ...overrideStyles }}
        />
      )
    }
    case 'AccessTime': {
      return <AccessTime fontSize={fontSize} style={{ ...overrideStyles }} />
    }
    case 'Shop': {
      return <LocalMall fontSize={fontSize} style={{ ...overrideStyles }} />
    }

    case 'Inventory': {
      return <Inventory fontSize={fontSize} style={{ ...overrideStyles }} />
    }

    case 'Map': {
      return <Map fontSize={fontSize} style={{ ...overrideStyles }} />
    }

    default: {
      return <TripOrigin fontSize={fontSize} style={{ ...overrideStyles }} />
    }
  }
}
